import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";

import HeaderV2 from '../../../components/headerV2';
import TableSolicitacoes from '../../../components/totvs/tableSolicitacao';
import CardSolicitacoes from '../../../components/totvs/cardSolicitacao';
import SolicitacaoFilters from '../../../components/totvs/solicitacaoFilters';

import ItemNotFound from "../../../assets/img-undraw-search.svg";

import * as S from './styles';
import api from '../../../services/api';
import { theme } from '../../../styles/theme';
import { H6 } from '../../../styles/stylesTypography';
import PaginatorV2 from '../../../components/paginator/indexV2';
import TreatedArea from '../../../components/nova-home/treated-area';
import CircleDataTotvs from '../../../components/nova-home/circle-data-totvs';
import { isOmie } from '../../../services/globalFunctions';
import { isProdutoIncompativelComEstado } from '../../../components/totvs/cardSolicitacao/helpers';

export const compendioG = "@compendioG";

const SolicitacoesReceitas = ({ ...props }) => {
    const [search, setSearch] = useState("");
    const [viewMode, setViewMode] = useState(() =>
        typeof window !== "undefined" && window.innerWidth < 768 ? "card" : "table"
    );
    const [selectedFilters, setSelectedFilters] = useState({});
    const [startDateFilter, setStartDateFilter] = useState("");
    const [endDateFilter, setEndDateFilter] = useState("");
    const [showFilters, setShowFilters] = useState(false);

    const [prescriptions, setPrescriptions] = useState([]);
    const [filter, setFilter] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [limitItens, setLimitItens] = useState(20);
    const [offset, setOffset] = useState(0);
    const [totalResults, setTotalResults] = useState(0);

    const hasFilterOptions = Object.keys(filter || {}).some(
        (key) => Array.isArray(filter[key]) && filter[key].length > 0
    );

    const keyFilter = {
        agronomos: "Responsável Técnico",
        status: "Status",
        data_emissao: "Data Solicitação",
        fabricantes: "Defensivo",
        produtores: "Produtor",
        culturas: "Cultura",
    };

    // No plano Omie ocultamos os filtros de Responsável Técnico e Cultura (junto com as
    // colunas correspondentes na tabela, ver tableSolicitacao/index.js) - o FilterHistory
    // só renderiza chip pra chave presente nesse objeto.
    const filterParaExibir = isOmie()
        ? Object.fromEntries(Object.entries(filter).filter(([key]) => key !== 'agronomos' && key !== 'culturas'))
        : filter;

    const displayToKey = Object.fromEntries(Object.entries(keyFilter).map(([k, v]) => [v, k]));

    // produto_apto_estado vem cacheado do backend (calculado 1x na criação do rascunho) -
    // reavalia sob demanda só os itens já flagados incompatíveis (evita 1 chamada de
    // compêndio por item toda vez que a lista é aberta, ver revalidarCompendioRascunho em
    // totvs.service.ts).
    const revalidarProdutosIncompativeis = async (lista) => {
        if (!isOmie()) return lista;
        const incompativeis = lista.filter((item) => isProdutoIncompativelComEstado(item));
        if (incompativeis.length === 0) return lista;
        const atualizacoes = await Promise.all(
            incompativeis.map((item) =>
                api.put(`/rascunhos/${item.id}/revalidar-compendio`)
                    .then((res) => ({ id: item.id, relacoes: res?.data?.data }))
                    .catch(() => null)
            )
        );
        const porId = new Map(atualizacoes.filter(Boolean).map((a) => [a.id, a.relacoes]));
        if (porId.size === 0) return lista;
        return lista.map((item) =>
            porId.has(item.id)
                ? { ...item, agro_prescriptions_relations_orders: porId.get(item.id) }
                : item
        );
    };

    const consultEvent = async (selectedOptions, limitArg = limitItens, offsetArg = 0) => {
        setIsLoading(true);
        try {
            const normalized = {};
            Object.entries(selectedOptions || {}).forEach(([label, values]) => {
                const key = displayToKey[label];
                if (key) normalized[key] = values;
            });

            const payload = {
                pedido: search || "",
                agronomos: normalized.agronomos || [],
                status: normalized.status || [],
                produtores: normalized.produtores || [],
                culturas: normalized.culturas || [],
                fazendas: normalized.fazendas || [],
                fabricantes: normalized.fabricantes || [],
                defensivos: normalized.fabricantes || [],
                data_solicitacao: (normalized.data_emissao && normalized.data_emissao[0]) || "",
            };

            const response = await api.post(`/rascunhos?limit=${limitArg}&offset=${offsetArg}`, payload);
            const data = response?.data;
            const total = data?.data?.total ?? data?.total ?? 0;

            setPrescriptions(await revalidarProdutosIncompativeis(data?.data?.prescriptions || []));
            setFilter(data?.data?.filters || {});
            setTotalResults(total);
        } catch (error) {
            console.error('Erro ao consultar itens:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const getRonsavelUsuario = async () => {
        try {
            const response = await api.get(`/responsavel-usuario`);
            return response?.data?.agronomo_id || "";
        } catch (error) {
            console.error('Erro ao buscar usuário:', error);
        }
    };

    const getItens = async (limitArg = limitItens, offsetArg = offset) => {
        setIsLoading(true);
        try {
            const userId = await getRonsavelUsuario();
            let payload = {
                pedido: "",
                agronomos: userId !== null ? [userId] : [],
                status: [],
                data_solicitacao: "",
                defensivos: [],
                produtores: [],
                culturas: []
            };

            if (userId) {
                setSelectedFilters({ [keyFilter.agronomos]: [userId] });
            }

            let response = await api.post(`/rascunhos?limit=${limitArg}&offset=${offsetArg}`, payload);
            let data = response?.data;
            let prescriptions = data?.data?.prescriptions || [];

            if (prescriptions.length === 0) {
                setSelectedFilters({ [keyFilter.agronomos]: [] });
                payload = {
                    ...payload,
                    agronomos: []
                };
                response = await api.post(`/rascunhos?limit=${limitArg}&offset=${offsetArg}`, payload);
                data = response?.data;
                prescriptions = data?.data?.prescriptions || [];
            }

            const total = data?.data?.total ?? data?.total ?? 0;

            setPrescriptions(await revalidarProdutosIncompativeis(prescriptions));
            setFilter(data?.data?.filters || {});
            setTotalResults(total);
        } catch (error) {
            console.error('Erro ao buscar itens:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getItens(limitItens, offset);
    }, []);

    const handleFilterChange = (sel) => {
        setSelectedFilters(sel);
        setOffset(0);
        consultEvent(sel, limitItens, 0);
    };

    const handlePaginationChange = async (newLimit, newOffset) => {
        try {
            if (newLimit !== limitItens || newOffset !== offset) {
                setLimitItens(newLimit);
                setOffset(newOffset);
                await consultEvent(selectedFilters, newLimit, newOffset);
                setTimeout(() => {
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                }, 150);
            }
        } catch (error) {
            console.error('Erro ao paginar itens:', error);
        }
    };

    return (
        <S.Container>
            <HeaderV2 title="Solicitações de Receitas" />

            <S.Wrapper>
                <S.PageBody>
                    <SolicitacaoFilters
                        variant="desktop-sidebar"
                        hasFilterOptions={hasFilterOptions}
                        filterHistoryProps={{
                            history: filterParaExibir,
                            initialSelected: selectedFilters,
                            onChange: handleFilterChange,
                            startDateValue: startDateFilter,
                            endDateValue: endDateFilter,
                            filterKeys: keyFilter,
                            disabledRT: true,
                            width: "100%",
                            maxWidth: "none",
                            minWidth: "auto",
                            minWidthOptions: "10rem",
                            padding: "0",
                            flexWrap: "wrap",
                            flexDirection: "column",
                            backgroundColor: "transparent",
                            widthCustomSelect: "100%",
                        }}
                    />

                    <S.MainContent>
                        <SolicitacaoFilters
                            viewMode={viewMode}
                            onToggleView={() => setViewMode((prev) => prev === 'table' ? 'card' : 'table')}
                            search={search}
                            onSearchChange={(e) => setSearch(e.target.value)}
                            onSearchBlur={() => {
                                setOffset(0);
                                consultEvent(selectedFilters, limitItens, 0);
                            }}
                            onClearSearch={() => {
                                setSearch("");
                                setOffset(0);
                                consultEvent(selectedFilters, limitItens, 0);
                            }}
                            hasFilterOptions={hasFilterOptions}
                            showFilters={showFilters}
                            onOpenFilters={() => setShowFilters(true)}
                            onCloseFilters={() => setShowFilters(false)}
                            filterHistoryProps={{
                                history: filterParaExibir,
                                initialSelected: selectedFilters,
                                onChange: handleFilterChange,
                                startDateValue: startDateFilter,
                                endDateValue: endDateFilter,
                                filterKeys: keyFilter,
                                disabledRT: true,
                                width: "100%",
                                maxWidth: "none",
                                minWidth: "auto",
                                minWidthOptions: "10rem",
                                padding: "0",
                                flexWrap: "wrap",
                                flexDirection: "column",
                                backgroundColor: "transparent",
                                widthCustomSelect: "100%",
                            }}
                        />

                        <S.Content>
                            {prescriptions.length > 0 ? (
                                viewMode === 'table' ? (
                                    <>
                                        <TableSolicitacoes
                                            items={prescriptions}
                                            isLoading={isLoading}
                                            onDataChanged={() => getItens(limitItens, offset)}
                                        />

                                        <PaginatorV2
                                            perPage={limitItens}
                                            total={totalResults}
                                            onChange={(limit, nextOffset) => handlePaginationChange(limit, nextOffset)}
                                            totalItens={prescriptions.length}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <CardSolicitacoes items={prescriptions} maxWidth="1162px" onDataChanged={() => getItens(limitItens, offset)} />

                                        <PaginatorV2
                                            perPage={limitItens}
                                            total={totalResults}
                                            onChange={(limit, nextOffset) => handlePaginationChange(limit, nextOffset)}
                                            totalItens={prescriptions.length}
                                        />
                                    </>
                                )
                            ) : isLoading ? (
                                <S.LoadingContainer>
                                    <S.Loading />
                                </S.LoadingContainer>
                            ) : (
                                <S.ContainerItemNotFound>
                                    <img src={ItemNotFound} alt="" />

                                    <H6 color={theme.colors.gray.Cinza_2}>
                                        Nenhum item encontrado
                                    </H6>
                                </S.ContainerItemNotFound>
                            )}
                        </S.Content>
                    </S.MainContent>
                </S.PageBody>

                <S.ContainerOthersContent>
                    <S.ContainerOthersContentFirst>
                        <CircleDataTotvs />
                    </S.ContainerOthersContentFirst>

                    <TreatedArea isTotvs={true} />
                </S.ContainerOthersContent>
            </S.Wrapper>
        </S.Container>
    );
};

export default withRouter(SolicitacoesReceitas);
